<script setup lang="ts">
  import StuutLogoSvg from '@ui/assets/stuut-logo-sm.svg?component';
  import StuutLogoWhiteSvg from '@ui/assets/stuut-logo-white.svg?component';

  interface Props {
    white?: boolean;
  }

  defineProps<Props>();
</script>

<template>
  <div class="flex items-center">
    <StuutLogoWhiteSvg v-if="white" />
    <StuutLogoSvg v-else />
  </div>
</template>

<style scoped></style>
